import React from "react";

const AccessLevelFormFields = ({
  accessLevel,
  onChange,
  onReaderChange,
  note,
  user,
  users
}) => (
  <React.Fragment>
    <div className="form-group">
      <label className="control-label" htmlFor="name">
        Adgangsnivå (Betegnelse)
      </label>
      <input
        onChange={e => onChange(["accessLevel", "name"], e.target.value)}
        value={accessLevel.name}
        id="name"
        name="name"
        type="text"
        placeholder="Konsulenter"
        className="form-control input-md"
        required
      />
    </div>
    {users && (
      <div className="form-group">
        <label className="control-label" htmlFor="company">
          Selskap
        </label>
        <div className="input-group mb-2">
          <select
            onChange={e => onChange(["accessLevel", "user_id"], e.target.value)}
            id="company"
            name="company"
            className="form-control"
            value={accessLevel.user_id}
            required
          >
            <option value="">Velg</option>
            {Object.keys(users).map(id => (
              <option key={users[id].id} value={users[id].id}>
                {users[id].company}
              </option>
            ))}
          </select>
        </div>
      </div>
    )}
    <div className="form-group">
      <label className="control-label" htmlFor="accesslevel">
        Kortlesere
      </label>
      {accessLevel.readers.map(
        (al, idx) =>
          al !== null && (
            <div key={`reader-${idx}`} className="input-group mb-2">
              <select
                onChange={e => onReaderChange(idx, e.target.value)}
                key={`reader-${idx}`}
                value={al.id}
                id="accesslevel"
                name="accesslevel"
                className="form-control"
                required
              >
                <option value="">Velg</option>
                {user &&
                  user.readers.map(accessLevel => (
                    <option key={accessLevel.id} value={accessLevel.id}>
                      {accessLevel.name}
                    </option>
                  ))}
              </select>
              {idx !== 0 && (
                <div className="input-group-append">
                  <button
                    className="btn btn-danger"
                    type="button"
                    onClick={() =>
                      onChange(["accessLevel", "readers", idx], null)
                    }
                  >
                    Fjern
                  </button>
                </div>
              )}
            </div>
          )
      )}
      <button
        id="accessLevel"
        type="button"
        onClick={() =>
          onChange(["accessLevel", "readers", accessLevel.readers.length], "")
        }
        name="accessLevel"
        className="btn btn-primary"
      >
        Legg til kortleser
      </button>
    </div>
    {note && (
      <div className="form-group">
        <label className="control-label" htmlFor="note">
          Merknader
        </label>
        <textarea
          onChange={e => onChange(["accessLevel", "note"], e.target.value)}
          value={accessLevel.note}
          className="form-control"
          id="note"
          name="note"
        />
      </div>
    )}
  </React.Fragment>
);

export default AccessLevelFormFields;



// WEBPACK FOOTER //
// ./src/components/AccessLevelFormFields.js